// Analytics.tsx
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const GA_ID = "G-RX8329X9VM"

export default function Analytics() {
  const location = useLocation()

  useEffect(() => {
    if (!GA_ID || typeof window.gtag !== 'function') return

    window.gtag('config', GA_ID, {
      page_path: location.pathname + location.search
    })
  }, [location])

  return null
}